/* euroguard · Guía de instalación
   - Pestañas de producto: muestran una sola sección «Guía · Producto» y sincronizan el hash (#gravedad, #grifo, #ducha).
   - Barra fija con píldoras cuando las pestañas grandes salen de la vista.
   - Vídeos de YouTube con fachada: el iframe solo se carga al pulsar. */
(function () {
  'use strict';

  function initGuide(root) {
    root = root || document;
    var tabsWrap = root.querySelector('[data-guide-tabs]');
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-guide-product]'));
    if (!panels.length) return;
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-guide-tab]'));
    var switchBar = document.querySelector('[data-guide-switch]');
    var keys = panels.map(function (p) { return p.getAttribute('data-guide-product'); });
    document.documentElement.classList.add('eg-guide-js');

    function keyFromHash() {
      var h = (location.hash || '').replace(/^#/, '').toLowerCase();
      if (!h) return null;
      if (h.indexOf('guia-') === 0) h = h.slice(5);
      return keys.indexOf(h) > -1 ? h : null;
    }

    function activate(key, opts) {
      opts = opts || {};
      if (keys.indexOf(key) === -1) key = keys[0];
      panels.forEach(function (p) {
        var on = p.getAttribute('data-guide-product') === key;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
      triggers.forEach(function (t) {
        var on = t.getAttribute('data-guide-tab') === key;
        if (t.getAttribute('role') === 'tab') t.setAttribute('aria-selected', on ? 'true' : 'false');
        else t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (opts.updateHash !== false && history.replaceState) {
        try { history.replaceState(null, '', '#' + key); } catch (e) { /* noop */ }
      }
      if (opts.scroll) {
        var target = opts.scrollTarget || panels.filter(function (p) { return !p.hidden; })[0];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-guide-tab');
        var fromSwitch = switchBar && switchBar.contains(t);
        activate(key, { scroll: true, scrollTarget: fromSwitch ? null : tabsWrap });
      });
    });

    window.addEventListener('hashchange', function () {
      var k = keyFromHash();
      if (k) activate(k, { updateHash: false, scroll: true });
    });

    var initial = keyFromHash();
    activate(initial || keys[0], { updateHash: !!initial, scroll: !!initial });
    window.__egGuideActivate = activate;

    /* Barra fija: aparece cuando las pestañas grandes ya no se ven. */
    if (switchBar && tabsWrap && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        switchBar.hidden = !past;
      }, { threshold: 0 });
      io.observe(tabsWrap);
    }
  }

  /* Fachada de YouTube */
  function initYouTube(root) {
    (root || document).querySelectorAll('[data-yt]').forEach(function (fig) {
      var btn = fig.querySelector('[data-yt-play]');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var id = fig.getAttribute('data-yt');
        var title = fig.getAttribute('data-yt-title') || 'Vidéo';
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&hl=fr';
        iframe.title = title;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('loading', 'eager');
        btn.replaceWith(iframe);
        fig.classList.add('is-playing');
      });
    });
  }

  function boot() { initGuide(document); initYouTube(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { initYouTube(document); initGuide(document); });
  /* Editor de temas: al seleccionar una sección de producto oculta, mostrarla. */
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target && (e.target.matches('[data-guide-product]') ? e.target : e.target.querySelector('[data-guide-product]'));
    if (el && window.__egGuideActivate) window.__egGuideActivate(el.getAttribute('data-guide-product'), { updateHash: false });
  });
})();
